export const faqs = [
  {
    question: '什么是"性福生活"？它和普通的性教育有什么不同？',
    answer: '性福生活是一个全面的亲密关系知识平台，它不仅关注性健康知识，更涵盖情感连接、婚姻经营、两性沟通、心理健康和亲子关系等多个维度。与传统的性教育不同，我们采用温暖、科学、专业的方式，帮助伴侣从整体上提升关系质量，而不仅仅是生理层面的知识传授。',
  },
  {
    question: '我单身，这个网站的内容对我有用吗？',
    answer: '当然有用！亲密关系的智慧不仅仅适用于恋爱或婚姻中的人。了解情感连接、两性沟通和心理健康的知识，能帮助你建立更健康的恋爱观，为未来的关系做好准备。同时，很多关于自我成长和心理健康的内容，对个人生活也有极大的帮助。',
  },
  {
    question: '网站上的性健康内容是否专业可靠？',
    answer: '我们的内容团队包括注册心理咨询师、三甲医院医师、资深婚姻家庭咨询师等专业人士。所有性健康相关内容都经过专业审核，确保信息的科学性和准确性。但请注意，网站内容仅供参考，如有具体健康问题，请务必咨询专业医师。',
  },
  {
    question: '我觉得和伴侣的关系出现了问题，从哪里开始看比较好？',
    answer: '建议从"情感连接"和"两性沟通"两个分类开始阅读。很多时候，关系问题的核心在于沟通不畅和情感连接的减弱。了解这些基础知识后，你可以根据具体情况再深入研究"婚姻经营"或"心理健康"相关的内容。如果问题较为严重，我们也建议寻求专业的婚姻咨询帮助。',
  },
  {
    question: '如何订阅性福生活的更新内容？',
    answer: '你可以在网站底部的订阅区域输入你的邮箱地址，我们会定期发送最新的文章、专家观点和实用技巧到你的邮箱。我们承诺不会发送垃圾邮件，也绝不会将你的邮箱分享给第三方。你可以随时取消订阅。',
  },
  {
    question: '网站内容是否涉及成人内容？适合在公共场合浏览吗？',
    answer: '我们的内容以科普和教育为主，采用专业、得体的表达方式，不包含任何低俗或露骨的内容。所有文章都适合在任何场合阅读。我们致力于用温暖而有尊严的方式传播亲密关系知识，让每个人都能安心学习和成长。',
  },
];

export const testimonials = [
  {
    name: '小雅',
    role: '已婚5年',
    content: '偶然发现这个网站，看了几篇关于夫妻沟通的文章后，我和老公的关系真的改善了很多。以前总是因为小事吵架，现在学会了用"我陈述"来表达感受，效果惊人！',
    rating: 5,
  },
  {
    name: '阿强',
    role: '新婚1年',
    content: '作为一个直男，以前对亲密关系完全没有概念。性福生活的文章让我打开了新世界的大门，原来经营感情有这么多学问。感谢这个平台！',
    rating: 5,
  },
  {
    name: '丽丽',
    role: '已婚10年',
    content: '结婚十年，感觉和老公越来越像室友。在朋友推荐下来到这里，按照文章里的方法开始重新经营关系，现在每周五的约会之夜成了我们最期待的时刻。',
    rating: 5,
  },
  {
    name: '文博',
    role: '恋爱3年',
    content: '专业性很强但又不会让人觉得有距离感。尤其喜欢性健康知识板块，很多一直困惑的问题都得到了科学的解答。已经推荐给了好几个兄弟。',
    rating: 5,
  },
  {
    name: '思涵',
    role: '单亲妈妈',
    content: '离婚后一度对亲密关系失去信心。在这里学到了很多关于自我成长和心理健康的知识，慢慢找回了自信。现在终于明白，爱自己才是最重要的。',
    rating: 5,
  },
];